var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cookie-bar"},[_c('a',{staticClass:"cookie-bar__content",attrs:{"href":"http://privacy.gucci.com/","target":"_blank","rel":"noopener noreferrer"},domProps:{"innerHTML":_vm._s(_vm.$translate('cookies'))}})])}
var staticRenderFns = []

export { render, staticRenderFns }